import { useEffect } from 'react';

const useTitle = (title) => {
  function addTitle() {
    return (document.title = `سامانه جامع فوتاب - ${title}`);
  }

  useEffect(() => {
    document.title = `سامانه جامع فوتاب - ${title}`;
  }, [title]);

  return [addTitle];
};

export default useTitle;
